import React from "react";
import AccountCard from "./AccountCard";

const AccountCardList = ({queriedAccounts}) => {
   console.log("Here's queried Account", queriedAccounts)
	return (
		<div>
			{ queriedAccounts?.map((queriedAccount) => <AccountCard 
         queriedAccount={queriedAccount}/>)}
		</div>	
	)
}

export default AccountCardList;